import React, { useState, useEffect, useContext } from 'react';
import { CartContext } from '../context/CartContext';
import Skeleton from '@mui/material/Skeleton';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Diaporama from './Diaporama';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Home = ({ toggleCart, isCartOpen, setIsCartOpen }) => {
  const [categories, setCategories] = useState({});
  const [menus, setMenus] = useState([]);
  const [menusPicker, setMenusPicker] = useState([]);
  const { cartItems, addToCart } = useContext(CartContext);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [infosGenerales, setInfosGenerales] = useState(null);

  // Chargement de la carte
  useEffect(() => {
    fetch(`/assets/json/carte.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => {
        setCategories(data.categories);
        setMenus(data.menus);
        setMenusPicker(data['menus-picker']);
        setLoading(false);
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des données:', error);
        setLoading(false);
      });
  }, []);

  // Chargement des infos générales
  useEffect(() => {
   // console.log('useEffect infos-generales appelé');
    const fetchInfos = async () => {
      try {
        const res = await fetch(`/assets/json/infos-generale.json?v=${Date.now()}`);
        const contentType = res.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
         // console.log('Réponse non JSON reçue pour /assets/json/infos-generale.json');
          const text = await res.text();
        //  console.log('Contenu reçu :', text);
          return;
        }
        const data = await res.json();
        // console.log('Infos générales:', data);
        setInfosGenerales(data); // Stocke tout l'objet dans le state
        
      } catch (e) {
        console.log('Erreur fetch infos-generales', e);
      }
    };
    fetchInfos();
  }, []);

  const handleAddToCart = (item) => {
    addToCart(item);
    setSnackbarMessage(`${item.nom} ajouté au panier !`);
    setOpenSnackbar(true);
    setIsCartOpen(true); // Ouvrir le panier après l'ajout d'un article
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  const totalItemsInCart = cartItems.reduce((total, item) => {
    if (item.quantity) {
      return total + item.quantity;
    } else {
      return total + 1;
    }
  }, 0);

  return (
    <div className="home-page">
      {loading ? (
        <Skeleton variant="rectangular" width={300} height={400} />
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2rem',
            maxWidth: 1100,
            margin: '2rem auto',
            flexWrap: 'wrap'
          }}
        >
          <div style={{ flex: '1 1 350px', minWidth: 280, maxWidth: 500 }}>
            <h1>
              Bienvenue chez {infosGenerales ? (infosGenerales.nomSite || infosGenerales.nom) : ""}
            </h1>
            <p
              dangerouslySetInnerHTML={{
                __html: infosGenerales && infosGenerales.description ? infosGenerales.description : ""
              }}
            />
            <a href="/notre-carte-a-emporter" className="carte-link" style={{ display: 'inline-flex', alignItems: 'center', marginTop: 16, fontWeight: 600, fontSize: 18, textDecoration: 'none', textAlign: "center" }}>
              <RestaurantMenuIcon style={{ verticalAlign: 'middle', marginRight: 6 }} />
              Passez une commande à emporter directement sur notre site
            </a>
          </div>
          <div style={{ flex: '1 1 350px', minWidth: 280, maxWidth: 500 }}>
            <Diaporama />
          </div>          
        </div>
        
      )}
      
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Home;
